export const STATE_NAME = 'COMMON';
export const PREFIX = STATE_NAME + '_';

export const CHANGE_LANGUAGE = PREFIX + 'CHANGE_LANGUAGE';
export const CAMPAIGNS_MOBILE = PREFIX + 'CAMPAIGNS_MOBILE';
export const CAMPAIGNS_MOBILE_INDEX = PREFIX + 'CAMPAIGNS_MOBILE_INDEX';
